import type { PresetThemeId } from './types'

export interface ThemeOption {
  id: PresetThemeId
  name: string
  description: string
  preview: string
}

export const THEME_OPTIONS: readonly ThemeOption[] = [
  {
    id: 'clean',
    name: 'Строгая',
    description: 'Воздух, тонкая сетка и спокойная типографика.',
    preview: new URL('../themes/clean/preview.png', import.meta.url).href,
  },
  {
    id: 'graphite',
    name: 'Тёмная',
    description: 'Графитовый фон и точный яркий акцент.',
    preview: new URL('../themes/graphite/preview.png', import.meta.url).href,
  },
  {
    id: 'journal',
    name: 'Журнал',
    description: 'Крупный сериф и выразительный книжный ритм.',
    preview: new URL('../themes/journal/preview.png', import.meta.url).href,
  },
  {
    id: 'neon',
    name: 'Неон',
    description: 'Градиенты и мягкое свечение для большой сцены.',
    preview: new URL('../themes/neon/preview.png', import.meta.url).href,
  },
  {
    id: 'pastel',
    name: 'Пастель',
    description: 'Мягкие карточки и дружелюбная светлая палитра.',
    preview: new URL('../themes/pastel/preview.png', import.meta.url).href,
  },
] as const

export function themeName(id: string): string {
  if (id === 'custom') return 'Подобрана под тему'
  return THEME_OPTIONS.find((theme) => theme.id === id)?.name ?? id
}
